import * as v from "valibot";
import { baseContactFieldsCamelCase } from "./contact-base.model";

// Custom Field Schema
const customFieldSchema = v.object({
  id: v.string(),
  key: v.string(),
  value: v.string(),
});

// DND Settings Schema
const dndSettingsSchema = v.object({
  type: v.string(),
});

// Attribution Source Schema (Define fields based on API documentation)
const attributionSourceSchema = v.object({});

// Contact Schema
const contactSchema = v.object({
  // Spread the base contact fields
  ...baseContactFieldsCamelCase,

  locationId: v.optional(v.string()),
  emailLowerCase: v.optional(v.pipe(v.string(), v.email())),
  dnd: v.optional(v.boolean()),
  dndSettings: v.optional(dndSettingsSchema),
  source: v.optional(v.string()),
  assignedTo: v.optional(v.string()),
  dateAdded: v.optional(v.string()),
  dateUpdated: v.optional(v.string()),
  attachments: v.optional(v.string()),
  ssn: v.optional(v.string()),
  keyword: v.optional(v.string()),
  firstNameLowerCase: v.optional(v.string()),
  fullNameLowerCase: v.optional(v.string()),
  lastNameLowerCase: v.optional(v.string()),
  lastActivity: v.optional(v.string()),
  customFields: v.optional(v.array(customFieldSchema)),
  businessId: v.optional(v.string()),
  attributionSource: v.optional(attributionSourceSchema),
  lastAttributionSource: v.optional(attributionSourceSchema),
});

export type Contact = v.InferOutput<typeof contactSchema>;

export default contactSchema;
